import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'

/**
 * Gets a list of selection criteria.
 */
export const getSelectionCriteria = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/parametros/cotizacion/criterios`)
)

/**
 * save purchase order with selected offers
 */
export const savePurchaseOrder = factoryService(({ ...payload }) => {
  const body = {
    codigoSolicitud: payload.idRequest,
    ocVO: payload.purchaseOrder.map(item => ({
      cotizacion: item.idOffer,
      criterioCotizacion: {
        id: item.selectionCriteria ? item.selectionCriteria.idCriteria : '1',
        texto: item.selectionCriteria ? item.selectionCriteria.text : ''
      }
    }))
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/orden-compra/crear`, { body })
})

/**
 * get list of quotes in "PO Issued" status that have POs eliminated/canceled/rejected
 */
export const getQuotePurchaseOrderChangeStatus = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/alertasOCSolicitudes`)
)

/**
 * Gets different status of the purchase order
 */
export const getPurchaseOrderStatus = factoryService(({ purchaseOrderId, requestQuoteId }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/compra-agil/solicitud/cotizacion/orden/${purchaseOrderId}/${requestQuoteId}`
  )
})

/**
 * Change the status of the purchase order with offers canceled or rejected
 */
export const setStatusPurchaseOrder = factoryService(({ quoteId }) => {
  return postJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/cotizacion/${quoteId}/cerrarPorOcEliminada`
  )
})

/**
 * Disable alert purchase order with offers canceled or rejected
 */
export const disablePurchaseOrderAlerts = factoryService(({ quoteId }) => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/cotizacion/${quoteId}/desactivarAlertasOC`)
})

/**
 * Gets the purchase orders records by the quote identifier.
 */
export const getPurchaseOrdersHistory = factoryService(({ quoteId }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/historial/${quoteId}`)
})
export const postDeclarationDeserted = factoryService(payload => {
  const body = {
    idSolicitudCotizacion: payload.idSolicitudCotizacion,
    motivoDesierta: payload.motivoDesierta
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/desertar/`, { body })
})
